import React from 'react';
import { DataPoint } from '../utils/mockData';
import { WoundInfectionRiskChart } from './WoundInfectionRiskChart';
import { TimeSlider } from './TimeSlider';
import { StatusIndicator } from './StatusIndicator';
interface DataPageProps {
  data: DataPoint[];
  currentTimeIndex: number;
  setCurrentTimeIndex: (index: number) => void;
}
export const DataPage: React.FC<DataPageProps> = ({
  data,
  currentTimeIndex,
  setCurrentTimeIndex
}) => {
  const currentData = data[currentTimeIndex];
  return <div className="bg-white shadow rounded-lg" data-id="element-55">
      <div className="px-3 py-4 sm:px-4 sm:py-5 md:p-6" data-id="element-56">
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 sm:gap-0 mb-4 sm:mb-6" data-id="element-57">
          <h2 className="text-xl sm:text-2xl font-bold text-gray-900" data-id="element-58">
            Raw Data Analysis
          </h2>
          <div className="flex items-center" data-id="element-59">
            <span className="text-xs sm:text-sm text-gray-500 mr-2" data-id="element-60">
              Current Wound Status:
            </span>
            <StatusIndicator status={currentData.healthStatus} data-id="element-61" />
          </div>
        </div>
        <div className="bg-gray-50 p-3 sm:p-4 rounded-lg border border-gray-200 mb-4 sm:mb-6" data-id="element-62">
          <h3 className="text-base sm:text-lg font-medium text-gray-900 mb-3 sm:mb-4" data-id="element-63">
            Wound Infection Risk Chart
          </h3>
          <div className="h-60 sm:h-80" data-id="element-64">
            <WoundInfectionRiskChart data={data} currentIndex={currentTimeIndex} data-id="element-65" />
          </div>
        </div>
        <div className="bg-gray-50 p-3 sm:p-4 rounded-lg border border-gray-200 mb-4 sm:mb-6" data-id="element-66">
          <h3 className="text-base sm:text-lg font-medium text-gray-900 mb-3 sm:mb-4" data-id="element-67">
            Time Control
          </h3>
          <TimeSlider data={data} currentIndex={currentTimeIndex} onChange={setCurrentTimeIndex} data-id="element-68" />
        </div>
        <div className="bg-gray-50 p-3 sm:p-4 rounded-lg border border-gray-200" data-id="element-69">
          <h3 className="text-base sm:text-lg font-medium text-gray-900 mb-3 sm:mb-4" data-id="element-70">
            Raw Data Values
          </h3>
          <div className="overflow-x-auto -mx-3 sm:mx-0" data-id="element-71">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-72">
              <thead className="bg-gray-50" data-id="element-73">
                <tr data-id="element-74">
                  <th scope="col" className="px-4 sm:px-6 py-2 sm:py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-75">
                    Day
                  </th>
                  <th scope="col" className="px-4 sm:px-6 py-2 sm:py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-76">
                    Wound Infection Risk (%)
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-77">
                {currentData.days.map((day, idx) => <tr key={idx} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'} data-id="element-78">
                    <td className="px-4 sm:px-6 py-1 sm:py-2 whitespace-nowrap text-xs sm:text-sm text-gray-500" data-id="element-79">
                      {day}
                    </td>
                    <td className="px-4 sm:px-6 py-1 sm:py-2 whitespace-nowrap text-xs sm:text-sm text-gray-500" data-id="element-80">
                      {currentData.woundInfectionRiskValues[idx]?.toFixed(1) || '-'}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>;
};